var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":_vm.nama,"show":_vm.xshow,"width":"400px","submitText":''},on:{"update:show":function($event){_vm.xshow=$event}}},[_c('div',[_c('Grid',{staticStyle:{"height":"calc(100vh - 100px)"},attrs:{"datagrid":_vm.datagrid,"dbref":"SPD.SelPerjalananPegawai","dbparams":_vm.dbparams,"disabled":true,"columns":[
        {
          name: 'SPT',
          value: 'NoSPT',
          width: '120px',
        },
        {
          name: 'Tujuan',
          value: 'TempatTujuan',
          width: '120px',
        },
        {
          name: 'Berangkat',
          value: 'TglBerangkat',
          width: '120px',
        },
        {
          name: 'Kembali',
          value: 'TglKembali',
          width: '120px',
        },
        {
          name: 'Jml Hari',
          value: 'JmlHari',
          width: '120px',
        } ]},on:{"update:datagrid":function($event){_vm.datagrid=$event}},scopedSlots:_vm._u([{key:"row-NoSPT",fn:function(ref){
      var row = ref.row;
return [_c('v-btn',{attrs:{"color":"primary","small":"","text":""},on:{"click":function($event){return _vm.Download(row.PerjalananId)}}},[_vm._v(" "+_vm._s(row.NoSPT)+" ")])]}},{key:"row-JmlHari",fn:function(ref){
      var row = ref.row;
return [_vm._v(" "+_vm._s(row.JmlHari)+" hari ")]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }